const tourSearchInput = (tripId, isTripSearch) => (store) => {
  const { searchProgress, requestId, catalogKey, foundTotalTours, loadedToursCount } =
    (isTripSearch ? store.tripSearch.searchObj.tour : store.tour.tourSearches[tripId]) || {};

  return {
    searchProgress,
    requestId,
    catalogKey,
    foundTotalTours,
    loadedToursCount,
  };
};

export default tourSearchInput;
